import GetAppSystemsRequestModelBase from '../_generated/modelBases/get-app-systems-request-model-base';

export default class GetAppSystemsRequestModel extends GetAppSystemsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
